export default "__VITE_ASSET__Dlkcyxt4__"